import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "../hooks/useTranslation";

const TextBox = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        backgroundColor: "rgba(128, 128, 128, 0.2)", // Transparent grey
        borderRadius: 2,
        padding: 3,
        mb: 3,
        mx: "auto",
        maxWidth: "800px",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "#4caf50", // Green color
          fontWeight: "bold",
          // textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
        }}
      >
        {t("homePageTT.textBox")}
      </Typography>
    </Box>
  );
};

export default TextBox;
